import { queryInviterActivityHome } from '@/api';

const state = {
  homeInfo: {},
  shareUrl: '',
  pageData: {},
  shareConfig: {}
};

const getters = {};

const mutations = {
  setHomeInfo(state, payload) {
    state.homeInfo = payload;
  },
  setShareUrl(state, payload) {
    state.shareUrl = payload;
  },
  setPageData(state, payload) {
    state.pageData = payload;
  },
  setShareConfig(state, payload) {
    state.shareConfig = payload;
  }
};

const actions = {
  async fetchHomeInfo({ commit }, req) {
    const res = await queryInviterActivityHome(req);
    commit('setHomeInfo', res);
  }
};

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations
};
